var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0013 17.3327C4.39893 17.3327 0.667969 13.6017 0.667969 8.99935C0.667969 4.39697 4.39893 0.666016 9.0013 0.666016C13.6036 0.666016 17.3346 4.39697 17.3346 8.99935C17.3346 13.6017 13.6036 17.3327 9.0013 17.3327ZM9.0013 15.666C12.6832 15.666 15.668 12.6813 15.668 8.99935C15.668 5.31745 12.6832 2.33268 9.0013 2.33268C5.3194 2.33268 2.33464 5.31745 2.33464 8.99935C2.33464 12.6813 5.3194 15.666 9.0013 15.666ZM9.83463 8.99935H13.168V10.666H8.16797V4.83268H9.83463V8.99935Z",
    fill: "black",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.e91db0806458db2abf5bdb0bd27ed159.svg";
export { ForwardRef as ReactComponent };